<template>
    <div v-if="bizAuth.editContractPolicy.hasRight" class="page-setting edit-policy">
        <edit-policy-comp :class="{'fixed': listIsFixed}"></edit-policy-comp>
    </div>
</template>
<script>
import editPolicyComp from '@/components/bussiness/mgtCategory/houseMgt/editPolicy/editPolicyComp.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            listIsFixed: false
        }
    },
    mounted () {
        // window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        // window.removeEventListener('scroll', this.handleScroll);
        // document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        'bizAuth.editContractPolicy.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('biz-add-house-head')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('biz-add-house-head')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        editPolicyComp
    }
}
</script>
<style lang="scss">
    .edit-policy{
        position: relative;
        margin-top: 30px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/houseMgt/editPolicy.vue